import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const EnvelopeIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M3 5.25C2.5875 5.25 2.25 5.5875 2.25 6V7.03594L10.3359 13.6734C11.3062 14.4703 12.6984 14.4703 13.6688 13.6734L21.75 7.03594V6C21.75 5.5875 21.4125 5.25 21 5.25H3ZM2.25 9.94687V18C2.25 18.4125 2.5875 18.75 3 18.75H21C21.4125 18.75 21.75 18.4125 21.75 18V9.94687L15.0938 15.4125C13.2937 16.8891 10.7016 16.8891 8.90625 15.4125L2.25 9.94687ZM0 6C0 4.34531 1.34531 3 3 3H21C22.6547 3 24 4.34531 24 6V18C24 19.6547 22.6547 21 21 21H3C1.34531 21 0 19.6547 0 18V6Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default EnvelopeIcon
